/* eslint-disable guard-for-in */
/* eslint-disable jsx-control-statements/jsx-use-if-tag */
import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { Field, Row, Col } from '@cleartrip/bento'
import {
  validateEmail,
  validateMobileNumber,
  validatePassword,
  onlyNumbersRegex,
  isEmpty,
  resolveKeysInObjectsArrays
} from 'AccountsUtils'

import Modal from './Modal'
import { userSignIn, userResetPassword } from '../../pages/Trips/trips.helper'
import Dropdown from './Dropdown'
import USER_PROFILE_PAGE_CONTANTS from './UserProfileConstants'

import SignEmailML from './screens/signEmailML'

import LoginWithMobileMLP2 from './screens/loginWithMobileMLP2'

import VerifyMobileNumberML from './screens/VerifyMobileNumberML'

import EmailsLinkedML from './screens/EmailsLinkedML'

import VerifyEmailML from './screens/VerifyEmailML'

import CheckYourEmail from './screens/CheckYourEmail'
import LinkAccountsSuccess from './screens/AccountsLinkSuccess'
import Loader from './screens/Loader/Loader'

const isRtl = process.env.CONTENT_DIR === 'RTL'
function MLContainers({
  isPwa,
  isShowing,
  toggle,
  page,
  setIsGOpaque = () => {},
  setIsPOpaque = () => {},
  setIsNumberEditable = () => {},
  setIsEmailEditable = () => {},
  setIsEOpaque = () => {},
  setIsMOpaque = () => {},
  isNumberEditable,
  isEmailEditable,
  existingCtEmails,
  setUserNumber = () => {},
  setNewEmail = () => {},
  userNumber,
  setIsMobVisible = () => {},
  userDetail,
  setUserDetail,
  setToastMessagex = () => {},
  setIsEmailLinked = () => {},
  isEmailLinked
}) {
  const MOBILE_COUNTRY_CODES = {
    IN: { name: 'India', code: '91', min: 10, max: 10 }
  }

  const countryCode = 'IN'

  const defaultCode = MOBILE_COUNTRY_CODES[countryCode].code || ''
  const defaultMinLength = MOBILE_COUNTRY_CODES[countryCode].min || ''
  const defaultMaxLength = MOBILE_COUNTRY_CODES[countryCode].max || ''

  const [pageName, setPageName] = useState(page)

  const animationDefaultState = {
    isAnimate: false,
    direction: 'right',
    isFadeIn: false
  }
  const [animationParams, setAnimationParams] = useState(animationDefaultState)

  const [rememberCheckedStatus, setRememberCheckedStatus] = useState(true)
  const [signInError, setSignInError] = useState(false)
  const [isSignInButtonLoading, setSignInButtonLoading] = useState(false)

  const [email, setEmail] = useState('')
  const [isEmailValid, setEmailValid] = useState(true)
  const [password, setPassword] = useState('')

  const [isPasswordValid, setPasswordValid] = useState(true)

  const [defaultCountryCode, setDefaultCountryCode] = useState(
    isRtl ? `${defaultCode}+` : `+${defaultCode}`
  )
  const [defaultCountryCodeMinLen, setDefaultCountryCodeMinLen] = useState(
    defaultMinLength
  )
  const [defaultCountryCodeMaxLen, setDefaultCountryCodeMaxLen] = useState(
    defaultMaxLength
  )
  const [isMobileValid, setMobileValid] = useState(true)

  const [signInPasswordType, setSignInPasswordType] = useState(true)

  const [mobileNumber, setMobileNumber] = useState('')
  const [toggleDropdown, setToggleDropdown] = useState(false)
  const [linkedEmails, setLinkedEmails] = useState([])
  const [isFocus, setFocus] = useState(false)

  const [initialRender, setInitialRender] = useState(true)

  const animatedClass = classNames({
    'slide-in-right':
      animationParams.direction === 'right' && animationParams.isAnimate,
    'slide-in-left':
      animationParams.direction === 'left' && animationParams.isAnimate,
    'px-8': 'px-8'
  })
  const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
  const pathname = query.split('/')
  const pagePath = pathname[2]

  useEffect(() => {
    setLinkedEmails(existingCtEmails)
  }, [existingCtEmails])

  useEffect(() => {
    if (!isShowing) {
      setPageName(null)
    } else setPageName(page)
  }, [page, isShowing])
  const setToDefault = () => {
    setMobileValid(true)
    setEmailValid(true)
    setPasswordValid(true)

    setSignInError(false)

    setEmail('')

    setPassword('')

    setSignInPasswordType(true)

    setMobileNumber('')
    setToggleDropdown(false)
  }
  useEffect(() => {
    if (pageName === 'SIGNIN' || pageName === 'RESET') {
      setToDefault()
    } else if (pageName === 'EMAIL_MOBILE_LINKED') {
      setMobileValid(true)
      setMobileNumber('')
      setToggleDropdown(false)
    }
  }, [pageName])

  useEffect(() => {
    setEmail(userDetail.username)
  }, [userDetail])

  function clickHandler(givenPage, isAnimate) {
    setAnimationParams({ isAnimate, direction: isRtl ? 'left' : 'right' })

    setPageName(givenPage)
    setTimeout(() => {
      setAnimationParams(animationDefaultState)
    }, 300)
  }

  const resendResetPassword = async () => {
    const resetPwdResponse = await userResetPassword(email)

    const { status: resetPwdStatus } = resetPwdResponse || {}

    if (resetPwdStatus === 202) {
      return true
    }
    return false
  }

  const handleLinkClick = url => {
    const dest = `${window.location.origin}/${url}`
    window.open(dest, '_blank')
  }
  const changeEmailHandler = e => {
    setEmailValid(true)

    setEmail(e.target.value)
  }
  const validateEmailHandler = e => {
    const temp = validateEmail(email)
    setEmailValid(temp)
    return temp
  }

  const handleOnFocus = () => {
    setFocus(true)
  }

  const changePasswordHandler = e => {
    setPasswordValid(true)
    setPassword(e.target.value)
  }

  const validatePasswordHandler = e => {
    const temp = validatePassword(password)
    setPasswordValid(temp)
    return temp
  }

  const validateMobileHandler = e => {
    const isMobileNumberValid = validateMobileNumber(
      userNumber,
      defaultCountryCodeMinLen,
      defaultCountryCodeMaxLen
    )
    setMobileValid(isMobileNumberValid)
    return isMobileNumberValid
  }
  const changeMobileHandler = e => {
    const mobile = e.target.value
    if (!isEmpty(mobile) && !onlyNumbersRegex.test(mobile)) {
      return
    }
    if (mobile.length <= defaultCountryCodeMaxLen) {
      setMobileValid(true)
      setMobileNumber(mobile)
    }
  }
  const countryCodeHandler = (code, min, max) => {
    if (isRtl) setDefaultCountryCode(`${code}+`)
    else setDefaultCountryCode(`+${code}`)
    setDefaultCountryCodeMinLen(min)
    setDefaultCountryCodeMaxLen(max)
    setToggleDropdown(toggleDropdown === code ? true : code)
    setMobileValid(true)
  }
  const mobileCountryCodesItem = codeObj => {
    const { name, code, min, max } = codeObj
    return (
      <Dropdown.Item
        selected={`+${code}` === defaultCountryCode}
        className="fs-3  hover:bg-secondary-500 c-pointer hover:c-white"
        onClick={() => countryCodeHandler(code, min, max)}
      >
        {name} (+{code})
      </Dropdown.Item>
    )
  }
  const populateMobileCountryCode = () => {
    const mobileCountryCodes = []

    for (const countryCodenew in MOBILE_COUNTRY_CODES) {
      const codeObj = MOBILE_COUNTRY_CODES[countryCodenew]
      mobileCountryCodes.push(mobileCountryCodesItem(codeObj))
    }
    return mobileCountryCodes
  }

  const toggleModalAndClosePage = () => {
    setTimeout(() => {
      toggle()
    }, 300)
    setTimeout(() => {
      window.location.reload()
    }, 400)
  }
  const dismissalPage = () => {
    switch (pageName) {
      case USER_PROFILE_PAGE_CONTANTS.SIGNINML:
        return 'Entering_mobile_numberml'
      case USER_PROFILE_PAGE_CONTANTS.SIGNIN:
        return 'Entering_mobile_number'
      case USER_PROFILE_PAGE_CONTANTS.RESET_PAGE:
        return 'Enter_email_for_reset'
      case USER_PROFILE_PAGE_CONTANTS.SIGNUP_PAGE:
        return 'Entering_mobile_number'
      case USER_PROFILE_PAGE_CONTANTS.RESET_CONFIRMATION_PAGE:
        return 'Reset_password_link_sent'
      case USER_PROFILE_PAGE_CONTANTS.SIGNEDIN_USER_PAGE:
        return ''
      case USER_PROFILE_PAGE_CONTANTS.SIGNUP_FORM_PAGE:
        return ''
      case USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBER:
        return 'Entering_OTP'
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED:
        return 'Selecting_linked_emails'
      case USER_PROFILE_PAGE_CONTANTS.VERIFY_EMAIL:
        return 'Entering_OTP'
      case USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS:
        return 'Linking_accounts'
      case USER_PROFILE_PAGE_CONTANTS.SIGNIN_EMAIL:
        return 'Email_login'
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED:
        return 'Enterig_mobile_number_after_email_sign_in'
      case USER_PROFILE_PAGE_CONTANTS.LINK_SUCCESS:
        return ''
      case USER_PROFILE_PAGE_CONTANTS.LOADER:
        return ''
      case USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS:
        return 'Enter_personal_details'
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED_PERSONAL_DETAILS:
        return 'Email_linked_personal_details'
      default:
        return ''
    }
  }
  function handleSignInToggle() {
    setMobileNumber('')
    const dismissalPoint = dismissalPage()
    return dismissalPoint
  }
  let spanClass =
    'fs-2 c-secondary-500 c-pointer hover:td-underline p-absolute h-9 flex flex-middle r-2 fw-500 t-0'
  if (isRtl) {
    spanClass =
      'fs-2 c-secondary-500 c-pointer hover:td-underline p-absolute h-9 flex flex-middle l-2 fw-500 t-0'
  }
  let checkboxClass = 'nl-1'
  if (isRtl) {
    checkboxClass = ''
  }
  let checkBoxTextClass = 'pl-1 c-neutral-700  fs-2 nl-1'
  if (isRtl) {
    checkBoxTextClass = 'pr-2 c-neutral-700  fs-2 '
  }

  let errorInfo = 'fs-inherit c-inherit pl-2'
  if (isRtl) {
    errorInfo = 'fs-inherit c-inherit pr-2'
  }

  const mobileAndCountryCodeItem = (
    <Row className="w-328">
      <Col span="4">
        <Dropdown overlay={false} toggle={toggleDropdown}>
          <Dropdown.Select
            hasError={!isMobileValid}
            className="h-9 p-0 px-2 fs-3"
            width={80}
            label={defaultCountryCode}
          />
          <Dropdown.Menu
            width={196}
            className="oy-auto"
            style={{ maxHeight: '198px' }}
          >
            {populateMobileCountryCode()}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
      <Col>
        <Field
          data-testid="Mobile"
          type="tel"
          placeholder="Enter mobile number"
          onChange={changeMobileHandler}
          onBlur={validateMobileHandler}
          hasError={!isMobileValid}
          onFocus={handleOnFocus}
          value={mobileNumber}
        />
      </Col>
    </Row>
  )

  async function redirectToPage() {
    if (isEmpty(email)) {
      setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED)
    } else {
      setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
    }
  }

  const onContinueML = async () => {
    setSignInButtonLoading(true)
    setSignInError('')
    const emailValidation = validateEmailHandler()
    setEmailValid(emailValidation)
    if (emailValidation && isEmailValid && email) {
      const payload = {
        username: email,
        password
      }

      const apiResponse = await userSignIn(payload)

      const { data, status } = apiResponse
      const { status: dataStatus } = data || {}

      if (status !== 200 || dataStatus === 'INTERNAL_SERVER_ERROR') {
        const {
          error: { response: { data: { message = '' } = {} } = {} } = {}
        } = apiResponse
        if (
          apiResponse.error.response.status === 410 &&
          apiResponse.error.response.data.message === 'AUTHENTICATION_ERROR'
        ) {
          setSignInError('Password doesn’t exist or has expired.')
          setPasswordValid(false)
        } else if (message.includes('username and password do not match')) {
          setSignInError('Entered email and password does not match.')

          setPasswordValid(false)
        } else if (message.includes('no user found')) {
          setSignInError('Entered email is not found')
          setEmailValid(false)
          setPasswordValid(false)
        } else {
          setSignInError('Something went wrong. Please try again.')
        }
        setSignInButtonLoading(false)
        return false
      }
      if (status === 200) {
        const { user = {} } = data || {}
        if (
          (!isEmpty(user.mobile) && !isEmpty(user.countryCode)) ||
          (user.peopleNudge && user.peopleNudge.mobile === true) ||
          (pathname.length > 4 &&
            pathname[4] === 'info' &&
            pathname[2] === 'itinerary')
        ) {
          setTimeout(() => {
            window.location.reload()
          }, 100)
        } else {
          setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED)
        }
        setSignInButtonLoading(false)
      }
    } else {
      setSignInButtonLoading(false)
    }
  }
  const SigninBlockML = (
    <SignEmailML
      isPwa={isPwa}
      isFocus={isFocus}
      animatedClass={animatedClass}
      toggle={handleSignInToggle}
      signInError={signInError}
      validateEmailHandler={validateEmailHandler}
      changeEmailHandler={changeEmailHandler}
      isEmailValid={isEmailValid}
      email={email}
      setEmail={setEmail}
      validatePasswordHandler={validatePasswordHandler}
      changePasswordHandler={changePasswordHandler}
      isPasswordValid={isPasswordValid}
      password={password}
      spanClass={spanClass}
      checkboxClass={checkboxClass}
      rememberCheckedStatus={rememberCheckedStatus}
      setRememberCheckedStatus={setRememberCheckedStatus}
      checkBoxTextClass={checkBoxTextClass}
      onContinueML={onContinueML}
      isLoading={isSignInButtonLoading}
      errorInfo={errorInfo}
      pagePath={pagePath}
      clickHandler={clickHandler}
      handleLinkClick={handleLinkClick}
      setPageName={setPageName}
      signInPasswordType={signInPasswordType}
      setSignInPasswordType={setSignInPasswordType}
      setIsGOpaque={setIsGOpaque}
      setIsPOpaque={setIsPOpaque}
      setIsMOpaque={setIsMOpaque}
      setIsEmailEditable={setIsEmailEditable}
      isEmailEditable={isEmailEditable}
      setNewEmail={setNewEmail}
    />
  )
  const MobileSignInUpBlockml = (
    <LoginWithMobileMLP2
      isPwa={isPwa}
      isFocus={isFocus}
      mobileAndCountryCodeItem={mobileAndCountryCodeItem}
      setPageName={setPageName}
      pageName={pageName}
      validateMobileHandler={validateMobileHandler}
      isMobileValid={isMobileValid}
      handleLinkClick={handleLinkClick}
      toggle={handleSignInToggle}
      email={email}
      mobile={mobileNumber}
      countryCode={defaultCountryCode}
      setMobileValid={setMobileValid}
      initialRender={initialRender}
      setInitialRender={setInitialRender}
      setIsGOpaque={setIsGOpaque}
      setIsEOpaque={setIsEOpaque}
      setIsPOpaque={setIsPOpaque}
      setIsNumberEditable={setIsNumberEditable}
      isNumberEditable={isNumberEditable}
      setUserNumber={setUserNumber}
      userNumber={userNumber}
    />
  )

  const VerifyNumberBlockml = (
    <VerifyMobileNumberML
      isPwa={isPwa}
      isFocus={isFocus}
      toggle={handleSignInToggle}
      mobileNumber={userNumber}
      defaultCountryCode={defaultCountryCode}
      setPageName={setPageName}
      checkboxClass={checkboxClass}
      rememberCheckedStatus={rememberCheckedStatus}
      setRememberCheckedStatus={setRememberCheckedStatus}
      checkBoxTextClass={checkBoxTextClass}
      redirectToPage={redirectToPage}
      email={email}
      setMobileNumber={setUserNumber}
      toggleModalAndClosePage={toggleModalAndClosePage}
      setLinkedEmails={setLinkedEmails}
      setIsGOpaque={setIsGOpaque}
      setIsEOpaque={setIsEOpaque}
      setIsPOpaque={setIsPOpaque}
      setIsNumberEditable={setIsNumberEditable}
      isNumberEditable={isNumberEditable}
      setIsMobVisible={setIsMobVisible}
      userDetail={userDetail}
      setUserDetail={setUserDetail}
      setToastMessagex={setToastMessagex}
    />
  )

  const VerifyEmailBlockml = (
    <VerifyEmailML
      toggle={handleSignInToggle}
      email={email}
      setPageName={setPageName}
      checkboxClass={checkboxClass}
      rememberCheckedStatus={rememberCheckedStatus}
      setRememberCheckedStatus={setRememberCheckedStatus}
      checkBoxTextClass={checkBoxTextClass}
      redirectToPage={redirectToPage}
      toggleModalAndClosePage={toggleModalAndClosePage}
      setIsGOpaque={setIsGOpaque}
      setIsMOpaque={setIsMOpaque}
      setIsPOpaque={setIsPOpaque}
      setIsEmailEditable={setIsEmailEditable}
      isEmailEditable={isEmailEditable}
      userDetail={userDetail}
      setUserDetail={setUserDetail}
      setToastMessagex={setToastMessagex}
      setIsEmailLinked={setIsEmailLinked}
      isEmailLinked={isEmailLinked}
    />
  )

  const EmailLinkedml = (
    <EmailsLinkedML
      toggle={handleSignInToggle}
      mobileNumber={mobileNumber}
      defaultCountryCode={defaultCountryCode}
      email={email}
      linkedEmails={linkedEmails}
      setEmail={setEmail}
      setPageName={setPageName}
      handleLinkClick={handleLinkClick}
      userDetail={userDetail}
      setUserDetail={setUserDetail}
      setIsEmailLinked={setIsEmailLinked}
      isEmailLinked={isEmailLinked}
    />
  )

  const LoaderBlock = <Loader />
  const LinkAccountsSuccessBlock = <LinkAccountsSuccess />

  const ResetConfirmationBlock = (
    <CheckYourEmail
      toggle={handleSignInToggle}
      setPageName={setPageName}
      setEmail={setEmail}
      clickHandler={clickHandler}
      email={email}
      resendResetPassword={resendResetPassword}
    />
  )
  const renderPage = () => {
    switch (pageName) {
      case USER_PROFILE_PAGE_CONTANTS.SIGNINML:
        return MobileSignInUpBlockml

      case USER_PROFILE_PAGE_CONTANTS.RESET_CONFIRMATION_PAGE:
        return ResetConfirmationBlock

      case USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBERML:
        return VerifyNumberBlockml
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKEDML:
        return EmailLinkedml

      case USER_PROFILE_PAGE_CONTANTS.VERIFY_EMAILML:
        return VerifyEmailBlockml
      case USER_PROFILE_PAGE_CONTANTS.SIGNIN_EMAILML:
        return SigninBlockML

      case USER_PROFILE_PAGE_CONTANTS.LINK_SUCCESS:
        return LinkAccountsSuccessBlock
      case USER_PROFILE_PAGE_CONTANTS.LOADER:
        return LoaderBlock

      default:
        return null
    }
  }

  return pageName === 'SIGNINML' ||
    pageName === 'VERIFY_MOBILE_NUMBERML' ||
    pageName === 'SIGNIN_EMAILML' ||
    pageName === 'VERIFY_EMAILML' ||
    pageName === 'EMAIL_LINKEDML' ? (
      <>{renderPage()}</>
    ) : (
      <Modal
        isShowing={isShowing}
        overlayClassName="z-70"
        overlayStyle={{ zIndex: 10000 }}
      >
        {renderPage()}
      </Modal>
    )
}

export default MLContainers
